var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCouverture(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_573_4080)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.99951 35.5311L23.9928 13.5378L45.9861 35.5311",
    stroke: "#A3AED0",
    strokeWidth: 4.05876
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.24756 28.5288L7.99763 48.9125",
    stroke: "#A3AED0",
    strokeWidth: 4.05876
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9878 12.9235V48.9125",
    stroke: "#A3AED0",
    strokeWidth: 4.05876
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9896 13.5378V23.5348",
    stroke: "#A3AED0",
    strokeWidth: 4.05876
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.9872 13.5378L31.9902 13.5378",
    stroke: "#A3AED0",
    strokeWidth: 4.05876
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_573_4080)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.99739 18.1332C6.23404 18.1332 4.68257 17.519 3.34298 16.2905C2.00284 15.0614 1.33276 13.3986 1.33276 11.302C1.33276 9.98294 1.83261 8.55282 2.83231 7.01163C3.832 5.47043 5.34543 3.80427 7.37258 2.01315C7.45589 1.94373 7.55309 1.88819 7.66416 1.84654C7.77524 1.80488 7.88632 1.78406 7.99739 1.78406C8.10847 1.78406 8.21955 1.80488 8.33063 1.84654C8.4417 1.88819 8.5389 1.94373 8.6222 2.01315C10.6494 3.80427 12.1628 5.47043 13.1625 7.01163C14.1622 8.55282 14.662 9.98294 14.662 11.302C14.662 13.3986 13.992 15.0614 12.6518 16.2905C11.3122 17.519 9.76074 18.1332 7.99739 18.1332ZM8.22649 15.634C8.39311 15.6201 8.53556 15.5543 8.65386 15.4366C8.7716 15.3183 8.83047 15.1758 8.83047 15.0092C8.83047 14.8148 8.76799 14.6587 8.64303 14.541C8.51807 14.4227 8.35839 14.3705 8.16401 14.3844C7.59474 14.426 6.99076 14.27 6.35206 13.9162C5.71337 13.5618 5.31071 12.9195 5.1441 11.9893C5.11633 11.8365 5.0433 11.7116 4.925 11.6144C4.80726 11.5172 4.67202 11.4686 4.51929 11.4686C4.3249 11.4686 4.16523 11.5414 4.04027 11.6869C3.91531 11.8329 3.87365 12.0032 3.91531 12.1975C4.15135 13.461 4.70673 14.3635 5.58147 14.905C6.4562 15.4465 7.33787 15.6895 8.22649 15.634V15.634Z",
    fill: "#A3AED0"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_573_4080"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(0 0.927124)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_573_4080"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.9939,
    height: 19.9939,
    fill: "white",
    transform: "translate(-1.99951 -1.07227)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCouverture);
export default __webpack_public_path__ + "static/media/Couverture.fd42a06db311ac3118016366018f3f0e.svg";
export { ForwardRef as ReactComponent };